module.exports = __webpack_public_path__ + "static/media/notebook-10.7e7261c6.png";